import React, { useState } from "react";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";
import Landing from "../Landing/Landing";
import Navbar from "../NavBar/Navbar";
import NavbarMenu from "../NavbarMenu/NavbarMenu";
import toparrow from "../../image/newImg/toparrow.png";
import SideBar from "../SideBar/SideBar";
import "./Content.css";
import "./Results.css";
import { Col } from "react-bootstrap";
import s10_1 from "../../image/result/Class 10 Topper 1.webp";
import s10_2 from "../../image/result/Class 10 Topper 2.webp";
import s12 from "../../image/result/Class 12 Topper.webp";


function Results(props) {
  const { cover, sidebar_data, side_heading, side_sub_heading } = props;
  const [isScrolled, setIsScrolled] = useState(false);
  const [isShow, steIsShow] = useState(false);
  const handleScroll = (e) => {
    if (e.target.scrollTop > 0 && !isScrolled) {
      setIsScrolled(true);
    }
    if (e.target.scrollTop === 0) {
      setIsScrolled(false);
    }
  };
  const handleClick = () => {
    steIsShow(!isShow);
    console.log(isShow);
  };

  return (
    <div className="content_main" onScroll={handleScroll}>
      <Navbar isScrolled={isScrolled} handleClick={handleClick} />
      <NavbarMenu isShow={isShow} handleClick={handleClick} />
      <Landing video={false} cover={cover} />
      <div className="contentmain_cont">
        <div style={{ width: "min-content" }}>
          <SideBar
            sidebar_data={sidebar_data}
            side_heading={side_heading}
            side_sub_heading={side_sub_heading}
          />
          <Contact />
        </div>
        <div>
          <div className={`f-2 f-500 mb-3`} style={{ color: "#1FDC00ED" }}>
            <img
              className="admissions__image"
              src={toparrow}
              alt=""
              style={{ marginRight: "1rem" }}
            />{" "}
            Results
          </div>
          <Col>
            <section className="board-results">
              <h2 className="board-result-title">
                Results CBSE Boards 2025-2026
              </h2>
              <div className="board-result-gallery">
                <img
                  className="studentimg"
                  src={s10_1}
                  alt="CBSE 10th board result topper 2025-2026"
                />
                <img
                  className="studentimg"
                  src={s10_2}
                  alt="CBSE 10th board result topper 2025-2026"
                />

                <h2 className="board-result-title">
                  Results CBSE 12th Boards 2025-2026:
                </h2>

                <img
                  className="studentimg"
                  src={s12}
                  alt="CBSE 12th board result topper 2025-2026"
                />
              </div>
            </section>
          </Col>
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default Results;
